import { render, staticRenderFns } from "./BecomePayingUser.vue?vue&type=template&id=4abd3a3b&scoped=true&"
import script from "./BecomePayingUser.vue?vue&type=script&lang=js&"
export * from "./BecomePayingUser.vue?vue&type=script&lang=js&"
import style0 from "./BecomePayingUser.vue?vue&type=style&index=0&id=4abd3a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd3a3b",
  null
  
)

export default component.exports